const SURNAME_ALLOWED_CHAR_PATTERN = /[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑýÝ '-]/;

type SurnameMaskFactory = ((value?: string) => string) & {
  patterns: {
    U: {
      pattern: RegExp;
    };
  };
};

export const SurnameMask: SurnameMaskFactory = Object.assign(
  () => 'U*',
  {
    patterns: {
      U: {
        pattern: SURNAME_ALLOWED_CHAR_PATTERN,
      },
    },
  }
);
